import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';

import RxOrderContainer from "../../containers/RxOrder";
import CommonContainer from "../../containers/Common";
import { Select } from '@material-ui/core';
import { Color } from 'openapi';

interface Props {
  rightMeganetLensMasterId: number,
  leftMeganetLensMasterId: number,
  meganetColorId: number | undefined,
  onChange: (meganetColorId: number) => void,
}

export default ((props) => {
  const rxOrderContainer = RxOrderContainer.useContainer();
  const commonContainer = CommonContainer.useContainer();
  const meganetColorId = props.meganetColorId || rxOrderContainer.colors[0].meganetColorId;

  const handleChange = (value: number) => {
    if (props.meganetColorId !== value) {
      props.onChange(value);
    }
  };

  var rightLensColorGroupIds = commonContainer.getColorGroupIdsByLensMasterId(props.rightMeganetLensMasterId);
  var leftLensColorGroupIds = commonContainer.getColorGroupIdsByLensMasterId(props.leftMeganetLensMasterId);

  // TransitionsStyleColor Number
  const transitionsStyleColor = 4;

  const rightLensColorGroup = rightLensColorGroupIds ? rightLensColorGroupIds.find(colorGroupId => colorGroupId.meganetColorGroupId === transitionsStyleColor) : false;
  const leftLensColorGroup = leftLensColorGroupIds ? leftLensColorGroupIds.find(colorGroupId => colorGroupId.meganetColorGroupId === transitionsStyleColor) : false;

  var colors: Color[] = [];
  var filteredColors = rxOrderContainer.getFilteredColors();
  // ビューフィット３ TR8B(SSVF3 TRST8) 専用のカラーのみ表示する - ColorGroupId 4
  if (rightLensColorGroup || leftLensColorGroup) {
    colors = filteredColors.filter((color: Color) => {
      if (color.meganetColorGroupId === transitionsStyleColor) {
        return color;
      }
    });
  }
  else {
    colors = filteredColors.filter((color: Color) => {
      if (color.meganetColorGroupId !== 4) {
        return color;
      }
    });
  }

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='color' label='Color' id='color' value={meganetColorId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleChange(Number(event.target.value))} component={Select}>
      <MenuItem style={{ height: 30, }} key={-1} value={-1}>--</MenuItem>
      {colors.map((color: Color) => (
        <MenuItem key={color.meganetColorId} value={color.meganetColorId}>{color.colorName}</MenuItem>)
      )}
    </Field>
  );
}) as React.FC<Props>;
